module.exports = __webpack_public_path__ + "static/media/todd-redfoot.717d65da.jpg";